import React, { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";


import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { loginStart, loginSuccess, loginFailed } from "../../Redux/userSlice";

const Signin = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");

    const url = "https://twitter-backend-v0gs.onrender.com/api"

    const dispatch = useDispatch();
    const navigate = useNavigate();


    const handleLogin = async (e) => {
        e.preventDefault();
        dispatch(loginStart());
        try {
            const res = await axios.post(`${url}/auth/signin`, { username, password });
            // console.log("DATA", res.data);
            // console.log("cookie", document.cookie);
            // const accessToken = Cookies.get("access_token");
            localStorage.setItem('accessToken', res.data.token);
            const accessToken = localStorage.getItem('accessToken');
            console.log("token", accessToken);

            dispatch(loginSuccess(res.data));
            navigate('/');
            console.log("signin", res.data);
        } catch (err) {
            dispatch(loginFailed());
        }
    }

    const handleSignUp = async (e) => {
        e.preventDefault();
        dispatch(loginStart());

        try {

            const res = await axios.post(`${url}/auth/signup`, { username, email, password });
            dispatch(loginSuccess(res.data));
            navigate("/");

        } catch (error) {
            dispatch(loginFailed());
        }
    }


    return (
        <form className="bg-gray-200 flex flex-col py-12 px-8 rounded-lg w-8/12 md:w-6/12 mx-auto gap-10">
            <h2 className="text-3xl font-bold text-center">Sign in to Twitter</h2>

            <input
                onChange={(e) => setUsername(e.target.value)}
                type="text"
                placeholder="username"
                className="text-xl py-2 rounded-full px-4"
            />
            <input
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                placeholder="password"
                className="text-xl py-2 rounded-full px-4"
            />

            <button
                onClick={handleLogin}
                className="text-xl py-2 rounded-full px-4 bg-blue-500 text-white"
            >
                Sign in
            </button>

            <p className="text-center text-xl">Don't have an account?</p>

            <input
                onChange={(e) => setUsername(e.target.value)}
                type="text"
                placeholder="username"
                className="text-xl py-2 rounded-full px-4"
            />
            <input
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                placeholder="email"
                required
                className="text-xl py-2 rounded-full px-4"
            />
            <input
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                placeholder="password"
                className="text-xl py-2 rounded-full px-4"
            />

            <button
                onClick={handleSignUp}
                className="text-xl py-2 rounded-full px-4 bg-blue-500 text-white"
                type="submit"
            >
                Sign up
            </button>
        </form>
    )
}

export default Signin;